(function ($) {

  if ($(".hero-slider .hero-slide").length > 1) {
    $(".hero-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 8000
    });
  }

})(jQuery);